import script from "./Historical.vue?vue&type=script&setup=true&lang=js"
export * from "./Historical.vue?vue&type=script&setup=true&lang=js"

import "./Historical.vue?vue&type=style&index=0&id=57a07e20&lang=scss"

const __exports__ = script;

export default __exports__